import React from 'react'
import './review.css'
import Navbar from './../../components/navbar/Navbar';
import Hero from './../../components/hero/Hero';

const Review = () => {
  return (
    <>
      <Navbar/>
      <Hero title="Make A Review"/>
    </>
  )
}

export default Review